// extracted by mini-css-extract-plugin
module.exports = {"container":"portfolioList-module--container--sR0My","col":"portfolioList-module--col--2b874","title":"portfolioList-module--title--2ixy9","gif":"portfolioList-module--gif--2VsEK"};